import React, { useState } from "react";
// import utils
//import component
import DCard from "../../components/DCard";
import Table from "../../components/Table";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import productServices from "../../services/products";
import { useNavigate } from "react-router-dom";
import DSpinner from "../../components/DSpinner";
import DImage from "../../components/DImage";
import DButton from "../../components/DButton";
import DModal from "../../components/DModal";
import { useDisclosure } from "@chakra-ui/react";
import { toast } from "react-hot-toast";

const columns = [
    { Header: "معرف المنتج", accessor: "id" },
    { Header: "الاسم", accessor: "name" },
    { Header: "الصورة", accessor: "img" },
    { Header: "القسم", accessor: "categoryname" },
    { Header: "نوع المنتج", accessor: "type" },
    { Header: "الحالة", accessor: "status" },
    { Header: "الترتيب", accessor: "order" },
    { Header: "التحكم", accessor: "actions" },
];
const Index = ({ title }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const queryClient = useQueryClient();
    const [currentProductId, setCurrentProductId] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const { data, isLoading, error } = useQuery(
        ["getProducts", currentPage],
        () => productServices.getAllProducts(currentPage + 1)
    );
    const navigate = useNavigate();
    const formattedData = data => {
        if (data?.length > 0) {
            return data.map(d => ({
                id: d.id,
                name: d.name,
                img: d.img ? (
                    <div className="relative max-w-[100px] h-[100px] mx-auto">
                        <DImage
                            className={"h-full object-cover w-full"}
                            src={d.img}
                            alt={d.img}
                            load={true}
                        />
                    </div>
                ) : (
                    "------"
                ),
                status: d.is_available === 1 ? "متاح" : "غير متاح",
                type: d.orphan === 1 ? "باقة" : "ليست باقة",
                categoryname: d.category.name_ar,
                order: d.order || "---",
                actions: (
                    <div className="flex items-center justify-center gap-2">
                        <DButton
                            onClick={() => {
                                navigate(`/products/${d.id}/sub-product`);
                            }}
                            className={
                                "text-white min-w-[75px] whitespace-nowrap rounded-[50px]"
                            }
                        >
                            اضافة باقة
                        </DButton>
                        <DButton
                            onClick={() => {
                                navigate(`/products/${d.id}`);
                            }}
                            bgColor="secondry"
                            className={
                                " min-w-[75px] whitespace-nowrap rounded-[50px]"
                            }
                        >
                            عرض الباقات
                        </DButton>
                        <DButton
                            bgColor="success"
                            className={
                                "text-white  min-w-[75px] rounded-[50px]"
                            }
                            onClick={() => navigate(`/products/edit/${d.id}`)}
                        >
                            تعديل
                        </DButton>
                        <DButton
                            bgColor="danger"
                            className={
                                "text-white  min-w-[75px] rounded-[50px]"
                            }
                            onClick={() => {
                                onOpen();
                                setCurrentProductId(d.id);
                            }}
                        >
                            حذف
                        </DButton>
                    </div>
                ),
            }));
        }
        return [];
    };
    const deleteProduct = () => {
        onClose();
        productServices
            .deleteProduct(currentProductId)
            .then(res => {
                toast.success("تم الحذف بنجاح");
                queryClient.refetchQueries(["getProducts"]);
            })
            .catch(err => {
                if (err.response.status === 404) {
                    toast.error("المنتج غير موجود");
                } else {
                    toast.error("حصل خطأ ما");
                }
            });
    };

    return (
        <div>
            <DModal
                isOpen={isOpen}
                onClose={onClose}
                modelType="delete"
                clickHandler={deleteProduct}
                bodyText="عند حذفك لهذا السجل قد يتم حذف سجلات مرتبطة به مثل
                        المنتجات الفرعية المرتبطة به - عمليات الطلب"
            />
            <PageHeading>{title}</PageHeading>
            <DCard className={`${isLoading ? "min-h-[400px]" : ""}`}>
                {isLoading ? (
                    <DSpinner />    
                ) : (
                    <Table
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalData={error ? 0 : data.data.total}
                        head={columns}
                        body={error ? [] : formattedData(data.data.data)}
                    />
                )}
            </DCard>
        </div>
    );
};

export default Index;
